import script from "./VipCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./VipCenter.vue?vue&type=script&setup=true&lang=js"

import "./VipCenter.vue?vue&type=style&index=0&id=05eb9672&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05eb9672"]])

export default __exports__